import { useEffect } from 'react';

export const useBeforeUnloadWarning = (
  message: string,
  shouldWarn: boolean,
  activeStep: number,
  stepperLength: number
) => {
  useEffect(() => {
    if (!shouldWarn) return;

    const handleBeforeUnload = (e: BeforeUnloadEvent) => {
      const isLastStep = activeStep === stepperLength + 1;
      if (isLastStep) return;

      e.preventDefault();
      return message;
    };

    window.addEventListener('beforeunload', handleBeforeUnload);
    return () => window.removeEventListener('beforeunload', handleBeforeUnload);
  }, [message, shouldWarn, activeStep, stepperLength]);
};
